import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";

import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApsServiceService } from "../aps-service.service";
import { ActivationEnd, Router } from "@angular/router";
import * as $ from "jquery";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  passwordErr: any = "";
  book: any = {}

  loaderdata: any = false;
  _packageids: getpackage[];
  _loginpackage: userpackage[];
  rate_usa: any = "00";
  rate_canada: any = "00";
  rate_other: any = "00";
  usachecked: any = false;
  canadachecked: any = false;
  otherchecked: any = false;
  getName: any;
  get_push_data: string[] = [];
  loginpackage: [];
  variable: number = 0;
  uservalue: any = null;
  loginyear: listyear[];
  usaplans: string[] = [];
  canadaplans: string[] = [];
  otherPlans: string[] = [];
  isLogin: any;
  token: any;
  listUSA: any;
  listCanada: any;
  listOthers: any;

  // new veriables 
  packageyear: any;
  sub_packagesdetails: any = '';





  form = new FormGroup({
    checkusa: new FormControl('', Validators.required),
    checkcanada: new FormControl('', Validators.required),
    checkother: new FormControl('', Validators.required),
    donationusa: new FormControl('', Validators.required),
    donationcanada: new FormControl('', Validators.required),
    donationother: new FormControl('', Validators.required),
    otherworlddata: new FormControl('', Validators.required),
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    confirmPassword: new FormControl('', Validators.required),


  });
  get checkusa(): any { return this.form.get('checkusa'); }
  get checkcanada(): any { return this.form.get('checkcanada'); }
  get checkother(): any { return this.form.get('checkother'); }
  get otherworlddata(): any { return this.form.get('otherworlddata'); }
  get donationusa(): any { return this.form.get('donationusa'); }
  get donationcanada(): any { return this.form.get('donationcanada'); }
  get donationother(): any { return this.form.get('donationother'); }
  get username(): any { return this.form.get('username'); }
  get password(): any { return this.form.get('password'); }
  get confirmPassword(): any { return this.form.get('confirmPassword'); }

  clearInputMethod1() {
    this.checkusa.reset(); this.checkcanada.reset(); this.checkother.reset(); this.otherworlddata.reset();
    this.donationusa.reset(); this.donationcanada.reset(); this.donationother.reset();
    this.username.reset(); this.password.reset(); this.confirmPassword.reset();
  }



  loginelement() {
    $(".login-section").fadeIn("slow").css("display", "flex");
  }

  closingdiv() {
    $(".login-section").on("click", function (e) {
      if (e.target !== this) {
        return;
      }
      $(".login-section").fadeOut("slow");
    });
  }

  closebtnlogin() {
    $(".login-section").fadeOut("slow");
  }
  closebtnreg() {
    $(".reg-section").fadeOut("slow");
  }

  regelement() {
    $(".reg-section").fadeIn("slow").css("display", "flex");
    // localStorage.clear();
  }
  closingdivreg() {
    $(".reg-section").on("click", function (e) {
      if (e.target !== this) {
        return;
      }
      $(".reg-section").fadeOut("slow");
    });
  }
  closedev() {
    //console.log("clicked");
  }

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private searchitem: ApsServiceService,
    private toastr: ToastrService
  ) { }



  click() {
    this.searchitem.contactUs()
    // this.router.navigate(['/']).then(()=>{});;

  }
  userLoggedIn():boolean{
    this.isLogin = localStorage.getItem('userid');
    this.token = localStorage.getItem('token')
    return this.isLogin&&this.token;
  }
  get3books() {
  
    if (this.userLoggedIn()) {
      this.searchitem.getereader(1, 3).subscribe({
        next: (value: any) => this.book = value
      })
    } else {
    
      this.searchitem.getTop3().subscribe({
        next: (value: any) => this.book = value
      })

    }
  }
 
 
  ngOnInit(): void {
    // what to remove
    //  this.hoverClick()

    this.get3books()


    this.getLoginPackage()

    // this.regelement()
    this.chekexpire()



    this.loaderdata = true;





    if (this.searchitem.subsVar == undefined) {
      this.searchitem.subsVar =
        this.searchitem.invokeFirstComponentFunction.subscribe(
          (name: string) => {
            this.closebtnlogin()
            this.regelement();
          }
        );
      this.searchitem.subsVar = this.searchitem.invokeUserreg.subscribe(
        (name: string) => {
          this.closebtnreg()
          this.loginelement();
        }
      );
    }


    $(".resp-nav-item").click(function () {
      $(".navbar-items").fadeToggle();
    });
    this._packageids = [
      { id: 1, name: "package1", isselected: false },
      { id: 2, name: "package2", isselected: false },
      { id: 3, name: "package3 ", isselected: false },
    ];

    if (localStorage.getItem("FirstName")) {
      this.getName =
        localStorage.getItem("FirstName") +
        " " +
        localStorage.getItem("LastName");
    }

    this.searchitem.getLoginPackage().subscribe((responce) => {
      //console.log(responce);
      var exampleArray = [];
      var listyeardata: any = [];
      exampleArray.push({ tribe_id: 1 });
      //console.log(exampleArray);

      this._loginpackage = [];
      var length = responce.plans.length;
      var plansdata = responce.plans;
      for (var i = 0; i < length; i++) {
        //console.log(i);
        const objects = new userpackage();
        objects.package_id = plansdata[i].planId;
        objects.name = plansdata[i].planename;
        objects.selecte_yearPlan = 0;
        objects.planyear = plansdata[i].palnyear.toString();

        objects.isselected = false;
        //console.log();
        for (let j = 0; j < plansdata[i].plan_validity.length; j++) {
          let yearplans: any = plansdata[i].plan_validity[j];
          const yearplane = new listyear();
          yearplane.plan_id = plansdata[i].plan_validity[j]?.yearplaneid;
          yearplane.planename = plansdata[i].plan_validity[j]?.yearofplan;
          yearplane.package_id = plansdata[i].planId;
          yearplane.planevalue = plansdata[i].plan_validity[j]?.rate;
          yearplane.isselected = false;
          listyeardata.push(yearplane);
          //console.log(listyeardata, "list");
        }
        objects.package_value.push(listyeardata);

        if (plansdata[i].planId == 1) {
          this.usaplans.push(listyeardata);

          //console.log(this.usaplans, "usa plan session");
        } else if (plansdata[i].planId == 2) {
          this.canadaplans.push(listyeardata);
          //console.log("canada") 
          //console.log(this.canadaplans) 
        } else if (plansdata[i].planId == 3) {
          this.otherPlans.push(listyeardata);
        }
        listyeardata = [];

        //console.log(objects);

        this._loginpackage.push(objects);
      }

      //console.log(this._loginpackage, "loginpackage");
      this.listUSA = this._loginpackage[0];
      this.listCanada = this._loginpackage[1];
      this.listOthers = this._loginpackage[2];
      //console.log(length + "length");
      this.loaderdata = false;
      //console.log(this.listUSA )
    });
  }

  hoverClick() {
   
    if (this.userLoggedIn()) {
      // this.get3books()
      return ;
    } else {
      this.router.navigate(['/']);
      this.toastr.warning('Register/Login to continue')
      return ;
    }

  }







  getdatas() {
    //console.log(this._loginpackage);
    //console.log(this._loginpackage[0].package_value["selecte_yearPlan"]);
  }

  firstFunction() {
    alert("Hello " + "\nWelcome to C# Corner \nFunction in First Component");
  }

  checkplanes(data) {
    //console.log(data);
    if (data == "other") {
      this.usachecked = false;
      this.canadachecked = false;
      this.otherchecked = true;
    } else if (data == "usa") {
      this.usachecked = true;
      this.canadachecked = false;
      this.otherchecked = false;
    } else if (data == "canada") {
      this.usachecked = false;
      this.canadachecked = true;
      this.otherchecked = false;
    } else {
      this.usachecked = false;
      this.canadachecked = false;
      this.otherchecked = false;
    }
  }
  onChangesusa(data) {
    //console.log(data);
    var i = this.usaplans[0].length;
    // //console.log(i)
    // //console.log(this.usaplans[0].length)
    for (let j = 0; j < i; j++) {
      //console.log(this.usaplans[0][j]["plan_id"]);
      if (this.usaplans[0][j]["plan_id"] == data) {
        this.rate_usa = this.usaplans[0][j]["planevalue"];
        //console.log("hii get id = ", this.usaplans[0][j]["plan_id"]);
        break;
      } else if (data == 0) {
        this.rate_usa = "00";
      }
    }

    // }
    // if(this.usaplans[0][0]?.palin_id == data )
    // this.rate_usa=data
  }
  onChangescanada(data) {
    var i = this.canadaplans[0].length;
    // //console.log(i)
    // //console.log(this.usaplans[0].length)
    for (let j = 0; j < i; j++) {
      //console.log(this.canadaplans[0][j]["plan_id"]);
      if (this.canadaplans[0][j]["plan_id"] == data) {
        this.rate_canada = this.canadaplans[0][j]["planevalue"];
        //console.log("hii get id = ", this.canadaplans[0][j]["plan_id"]);
        break;
      } else if (data == 0) {
        this.rate_canada = "00";
      }
    }

    // //console.log(data)
    // this.rate_canada=data
  }
  onChangesothers(data) {
    var i = this.otherPlans[0].length;
    // //console.log(i)
    // //console.log(this.usaplans[0].length)
    for (let j = 0; j < i; j++) {
      //console.log(this.otherPlans[0][j]["plan_id"]);
      if (this.otherPlans[0][j]["plan_id"] == data) {
        this.rate_other = this.otherPlans[0][j]["planevalue"];
        //console.log("hii get id = ", this.otherPlans[0][j]["plan_id"]);
        break;
      } else if (data == 0) {
        this.rate_other = "00";
      }
    }
    // //console.log(data)
    // this.rate_other=data
  }
  logout() {
    localStorage.clear();
    this.getName = "";
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
  }

  getpackage() {
    //console.log(this._packageids);
  }

  onClickSubmitlogin(data) {
    if (
      !data.password &&
      !data.username &&
      data.username == "" &&
      data.password == ""
    ) {
      this.toastr.warning("Enter Username and Password");
    } else {
      //console.log(data);
      this.loaderdata = true;
      this.searchitem.logindata(data).subscribe((responce) => {
        //console.log(responce.status);
        if (responce.status) {
          //console.log(responce);
          $(".login-section").fadeOut("slow");
          localStorage.setItem("FirstName", responce.FirstName);
          localStorage.setItem("LastName", responce.LastName);
          localStorage.setItem("userid", responce.userid);
          localStorage.setItem("token", responce.tokens);
          localStorage.setItem("directory", responce.directoryAccess);
          localStorage.setItem("privilege", responce.privilege);
          localStorage.setItem("flag", responce.flag);
          localStorage.setItem("issubscribe", responce.subdata)


          this.getName =
            localStorage.getItem("FirstName") +
            " " +
            localStorage.getItem("LastName");
          this.router.navigate(['/userpage'])
          this.loaderdata = false;
          this.get3books()
          // window.location.reload()
        } else {
          this.toastr.warning(
            "incorrect username or password please try again"
          );
          this.loaderdata = false;
        }
      });
    }
  }

  onClickSubmit(data) {
    localStorage.removeItem("planinfo");
    //console.log(this._loginpackage);
    //console.log(this.usaplans[0]);
    var display_plan = "";
    let planamount = "";
    if (data.Usaplan) {
      if (!data.Usaplanyear) {
        this.toastr.warning("Please Select Period");
      } else if (data.DonationUsa == " " || data.DonationUsa === null) {
        localStorage.removeItem("Donation");
        if (data.Usaplanyear == 1) {
          //console.log(this.usaplans[0][0]?.["planevalue"]);
          //console.log(   this._loginpackage[0].planyear + " " + this._loginpackage[0].name);
          localStorage.setItem(
            "planname",
            this._loginpackage[0].planyear + " " + this._loginpackage[0].name
          );
          localStorage.setItem("planyear", "1");
          localStorage.setItem(
            "planamount",
            this.usaplans[0][0]?.["planevalue"]
          );
          let plans =
            this._loginpackage[0].planyear +
            " " +
            this._loginpackage[0].name +
            " Plan " +
            this.usaplans[0][0]?.["planevalue"] +
            "USD";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
        if (data.Usaplanyear == 2) {
          //console.log(this.usaplans[0][1]?.["planevalue"]);
          //console.log(
          //  this._loginpackage[0].planyear + " " + this._loginpackage[0].name
          //); 
          localStorage.setItem(
            "planname",
            this._loginpackage[0].planyear + " " + this._loginpackage[0].name
          );
          localStorage.setItem("planyear", "2");
          localStorage.setItem(
            "planamount",
            this.usaplans[0][1]?.["planevalue"]
          );
          let plans =
            this._loginpackage[0].planyear +
            " " +
            this._loginpackage[0].name +
            " Plan " +
            this.usaplans[0][1]?.["planevalue"] +
            "USD";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
      } else {
        if (data.Usaplanyear == 1) {
          //console.log(this.usaplans[0][0]?.["planevalue"]);
          //console.log(
          //  this._loginpackage[0].planyear + " " + this._loginpackage[0].name
          // );
          localStorage.setItem(
            "planname",
            this._loginpackage[0].planyear + " " + this._loginpackage[0].name
          );
          localStorage.setItem("planyear", "1");
          localStorage.setItem(
            "planamount",
            this.usaplans[0][0]?.["planevalue"]
          );
          localStorage.setItem("Donation", data.DonationUsa);

          let plans =
            this._loginpackage[0].planyear +
            " " +
            this._loginpackage[0].name +
            " Plan " +
            this.usaplans[0][0]?.["planevalue"] +
            "USD + $" +
            data.DonationUsa +
            " DONATION";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
        if (data.Usaplanyear == 2) {
          //console.log(this.usaplans[0][1]?.["planevalue"]);
          //console.log(
          //   this._loginpackage[0].planyear + " " + this._loginpackage[0].name
          //  );
          localStorage.setItem(
            "planname",
            this._loginpackage[0].planyear + " " + this._loginpackage[0].name
          );
          localStorage.setItem("planyear", "2");
          localStorage.setItem(
            "planamount",
            this.usaplans[0][1]?.["planevalue"]
          );
          localStorage.setItem("Donation", data.DonationUsa);

          let plans =
            this._loginpackage[0].planyear +
            " " +
            this._loginpackage[0].name +
            " Plan " +
            this.usaplans[0][1]?.["planevalue"] +
            "USD + $" +
            data.DonationUsa +
            " DONATION";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
      }
    }
    if (data.Canadaplan) {
      if (!data.Canadaplanyear) {
        this.toastr.warning("Please Select Period");
      } else if (data.DonationCanada == " " || data.DonationCanada === null) {
        localStorage.removeItem("Donation");

        if (data.Canadaplanyear == 1) {
          //console.log(this.canadaplans[0][0]?.["planevalue"]);
          //console.log(
          //   this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          // );
          localStorage.setItem(
            "planname",
            this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          );
          localStorage.setItem("planyear", "1");
          localStorage.setItem(
            "planamount",
            this.canadaplans[0][0]?.["planevalue"]
          );
          let plans =
            this._loginpackage[1].planyear +
            " " +
            this._loginpackage[1].name +
            " Plan " +
            this.canadaplans[0][0]?.["planevalue"] +
            "USD";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
        if (data.Canadaplanyear == 2) {
          //console.log(this.canadaplans[0][1]?.["planevalue"]);
          //console.log(
          //   this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          //  );
          localStorage.setItem(
            "planname",
            this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          );
          localStorage.setItem("planyear", "2");
          localStorage.setItem(
            "planamount",
            this.canadaplans[0][1]?.["planevalue"]
          );
          let plans =
            this._loginpackage[1].planyear +
            " " +
            this._loginpackage[1].name +
            " Plan " +
            this.canadaplans[0][1]?.["planevalue"] +
            "USD";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
      } else {
        if (data.Canadaplanyear == 1) {
          //console.log(this.canadaplans[0][0]?.["planevalue"]);
          //console.log(
          //    this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          //  );
          localStorage.setItem(
            "planname",
            this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          );
          localStorage.setItem("planyear", "1");
          localStorage.setItem(
            "planamount",
            this.canadaplans[0][0]?.["planevalue"]
          );
          localStorage.setItem("Donation", data.DonationCanada);

          let plans =
            this._loginpackage[1].planyear +
            " " +
            this._loginpackage[1].name +
            " Plan " +
            this.canadaplans[0][0]?.["planevalue"] +
            "USD + $" +
            data.DonationCanada +
            " DONATION";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
        if (data.Canadaplanyear == 2) {
          //console.log(this.canadaplans[0][1]?.["planevalue"]);
          //console.log(
          //     this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          //   );
          localStorage.setItem(
            "planname",
            this._loginpackage[1].planyear + " " + this._loginpackage[1].name
          );
          localStorage.setItem("planyear", "2");
          localStorage.setItem(
            "planamount",
            this.canadaplans[0][1]?.["planevalue"]
          );
          localStorage.setItem("Donation", data.DonationCanada);

          let plans =
            this._loginpackage[1].planyear +
            " " +
            this._loginpackage[1].name +
            " Plan " +
            this.canadaplans[0][1]?.["planevalue"] +
            "USD + $" +
            data.DonationCanada +
            " DONATION";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
      }
    }

    if (data.Otherplan) {
      //console.log(data.otherplanyear + "user base");

      if (data.otherplanyear == " " || data.otherplanyear === null) {
        this.toastr.warning("Please Select Period");
      } else if (data.DonationOther == " " || data.DonationOther === null) {
        localStorage.removeItem("Donation");
        if (data.otherplanyear == 1) {
          //console.log(this.otherPlans[0][0]?.["planevalue"]);
          //console.log(
          //       this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          //   );
          localStorage.setItem(
            "planname",
            this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          );
          localStorage.setItem("planyear", "1");
          localStorage.setItem(
            "planamount",
            this.otherPlans[0][0]?.["planevalue"]
          );
          let plans =
            this._loginpackage[2].planyear +
            " " +
            this._loginpackage[2].name +
            " Plan " +
            this.otherPlans[0][0]?.["planevalue"] +
            "USD";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
        if (data.otherplanyear == 2) {
          //console.log(this.otherPlans[0][1]?.["planevalue"]);
          //console.log(
          //     this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          //  );
          localStorage.setItem(
            "planname",
            this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          );
          localStorage.setItem("planyear", "2");
          localStorage.setItem(
            "planamount",
            this.otherPlans[0][1]?.["planevalue"]
          );

          let plans =
            this._loginpackage[2].planyear +
            " " +
            this._loginpackage[2].name +
            " Plan " +
            this.otherPlans[0][1]?.["planevalue"] +
            "USD";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
      } else {
        //console.log(this.otherPlans);

        if (data.otherplanyear == 1) {
          //  _loginpackage[1].planyear}}
          //   {{_loginpackage[1].name}}

          //console.log(this.otherPlans[0][0]?.["planevalue"]);
          //console.log(
          //     this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          //    );
          localStorage.setItem(
            "planname",
            this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          );
          localStorage.setItem("planyear", "1");
          localStorage.setItem(
            "planamount",
            this.otherPlans[0][0]?.["planevalue"]
          );
          localStorage.setItem("Donation", data.DonationOther);

          let plans =
            this._loginpackage[2].planyear +
            " " +
            this._loginpackage[2].name +
            " Plan " +
            this.otherPlans[0][0]?.["planevalue"] +
            "USD + $" +
            data.DonationOther +
            " DONATION";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
        if (data.otherplanyear == 2) {

          //console.log(this.otherPlans[0][1]?.["planevalue"]);
          //console.log(
          //     this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          //   );
          localStorage.setItem(
            "planname",
            this._loginpackage[2].planyear + " " + this._loginpackage[2].name
          );
          localStorage.setItem("planyear", "2");
          localStorage.setItem(
            "planamount",
            this.otherPlans[0][1]?.["planevalue"]
          );
          localStorage.setItem("Donation", data.DonationOther);

          let plans =
            this._loginpackage[2].planyear +
            " " +
            this._loginpackage[2].name +
            " Plan " +
            this.otherPlans[0][1]?.["planevalue"] +
            "USD + $" +
            data.DonationOther +
            " DONATION";
          //console.log(plans);

          localStorage.setItem("planinfo", plans);
        }
      }
    }

    //console.log(data);
    // planname,planyear,planamount

    // if(!data.Otherplan && !data.Canadaplan && !data.Usaplan ){
    //   this.toastr.warning("Select Your Plan")
    // }else{

    if (
      !data.password ||
      data.password == "" ||
      !data.username ||
      !data.username ||
      !data.confrm_password ||
      !data.confrm_password
    ) {
      this.toastr.warning("Please enter all required information");
    } else {
      if (data.password != data.confrm_password) {
        this.passwordErr = "Password does not match!";
      } else if (
        !localStorage.getItem("planname") &&
        !localStorage.getItem("planyear") &&
        !localStorage.getItem("planamount")
      ) {
        //console.log("working");
        this.toastr.warning("Select Your Plan");
      } else {
        this.loaderdata = true;
        this.searchitem.Getusername(data.username).subscribe((responce) => {
          if (responce.status) {
            localStorage.setItem("username", data.username);
            localStorage.setItem("password", data.password);
            $(".reg-section").fadeOut("slow");

            this.router.navigate(["/myaccount"]).then(() => {
              window.location.reload();
              localStorage.getItem("planinfo")
            });
          } else {
            this.loaderdata = false;
            this.toastr.warning("Username Already Exists!");
          }
          this.loaderdata = false;
        });
      }
    }
  }



  // new changes add on


  getLoginPackage = () => {
    this.searchitem.getLoginsubPackage().subscribe((responce) => {
      this.sub_packagesdetails = responce.datas

    })

  }


  onClickSubmitnew() {
    this.passwordErr = '';

    var usa = this.form.get('checkusa').value
    var canada = this.form.get('checkcanada').value
    var other = this.form.get('checkother').value
    var username = this.form.get('username').value
    var password = this.form.get('password').value
    var confrm_password = this.form.get('confirmPassword').value
    var usa = this.form.get('checkusa').value
    var canada = this.form.get('checkcanada').value
    var other = this.form.get('checkother').value
    var plans = " ";
    // donationusa: new FormControl('',Validators.required),
    // donationcanada: new FormControl('',Validators.required),
    // donationother: new FormControl('',Validators.required),

    // donationusa: new FormControl('',Validators.required),
    // donationcanada: new FormControl('',Validators.required),
    // donationother: new FormControl('',Validators.required),

    if (usa || canada || other) {

      if (usa) {
        localStorage.setItem("planname", this.sub_packagesdetails[0].planname + " USA Membership Plan");
        localStorage.setItem("planamount", this.sub_packagesdetails[0].usa);

        if (this.form.get('donationusa').value != "" && this.form.get('donationusa').value != null) {
          localStorage.setItem("Donation", this.form.get('donationusa').value);
          plans = this.sub_packagesdetails[0].planname +
            " USA Membership Plan " +
            this.sub_packagesdetails[0].usa +
            "USD + $" +
            this.form.get('donationusa').value +
            " DONATION";

        } else {
          localStorage.removeItem("Donation");
          plans = this.sub_packagesdetails[0].planname +
            " USA Membership Plan " +
            this.sub_packagesdetails[0].usa +
            "USD"



        }

        localStorage.setItem("planinfo", plans);

      } else if (canada) {
        localStorage.setItem("planname", this.sub_packagesdetails[0].planname + " Canada / Mexico Membership");
        localStorage.setItem("planamount", this.sub_packagesdetails[0].canada);
        if (this.form.get('donationcanada').value != "" && this.form.get('donationcanada').value != null) {
          localStorage.setItem("Donation", this.form.get('donationcanada').value);
          plans = this.sub_packagesdetails[0].planname +
            " Canada / Mexico Membership " +
            this.sub_packagesdetails[0].canada +
            "USD + $" +
            this.form.get('donationcanada').value +
            " DONATION";


        } else {
          localStorage.removeItem("Donation");
          plans = this.sub_packagesdetails[0].planname +
            " Canada / Mexico Membership " +
            this.sub_packagesdetails[0].canada +
            "USD"



        }

        localStorage.setItem("planinfo", plans);

      } else if (other) {
        localStorage.setItem("planname", this.sub_packagesdetails[0].planname + " Rest of World");
        localStorage.setItem("planamount", this.sub_packagesdetails[0].other);

        if (this.form.get('donationother').value != "" && this.form.get('donationother').value != null) {
          localStorage.setItem("Donation", this.form.get('donationother').value);
          plans = this.sub_packagesdetails[0].planname +
            " Rest of World " +
            this.sub_packagesdetails[0].other +
            "USD + $" +
            this.form.get('donationother').value +
            " DONATION";


        } else {
          localStorage.removeItem("Donation");
          plans = this.sub_packagesdetails[0].planname +
            " Rest of World " +
            this.sub_packagesdetails[0].other +
            "USD"


        }

        localStorage.setItem("planinfo", plans);


      }

      // localStorage.setItem("planinfo", plans);




      if (username != "") {
        if (password == confrm_password) {



          this.loaderdata = true;
          this.searchitem.Getusername(username).subscribe((responce) => {
            if (responce.status) {

              this.loaderdata = false;
              localStorage.setItem("planyear", "1");
              localStorage.setItem("username", username);
              localStorage.setItem("password", password);
              $(".reg-section").fadeOut("slow");

              this.router.navigate(["/myaccount"]).then(() => {
                window.location.reload();
                localStorage.getItem("planinfo")
              });

            } else {


              this.loaderdata = false;
              this.toastr.warning("Username Already Exists!");
            }
          })


        } else {
          this.passwordErr = "Password does not match!";
        }
      } else {
        this.toastr.warning("Pleace Enter Username");

      }


    } else {
      // alert('true')
      this.toastr.warning("Select Your Plan");
    }



  }
  click_usa = () => {
    this.checkcanada.reset();
    this.checkother.reset();
  }

  click_canada = () => {
    this.checkusa.reset();
    this.checkother.reset();
  }
  click_other = () => {

    this.checkusa.reset();
    this.checkcanada.reset();
  }

  chekexpire = () => {
    // localStorage.setItem("issubscribe",'true')
    if (localStorage.getItem("userid")) {


      // console.log('calling expering')
      var userid = localStorage.getItem("userid")
      this.searchitem.ifchekexpire(userid).subscribe((responce) => {
        if (responce.status) {
          // console.log(responce)

          localStorage.setItem("issubscribe", 'true')
        } else {
          localStorage.setItem("issubscribe", 'false')
        }
      })
    } else {
      // console.log("no userid")
    }

  }








}

function closing() {
  throw new Error("Function not implemented.");
}




class getpackage {
  id: number;
  name: string;
  isselected: boolean;
}

class userpackage {
  package_id: any;
  name: any;
  package_value: string[] = [];
  selecte_yearPlan: any;
  planyear: any;
  isselected: any;
}
class listyear {
  plan_id: number;
  package_id: number;
  planename: any;
  planevalue: any;
  isselected: boolean;
}
